// 为了和功能组件库的路径一致，做了这个转包。
import IconFont from '../Base/IconFont';
export default IconFont;
